import { Link } from "@tanstack/react-router";
import { useAppTranslation } from "@/core/i18n";

export default function FeatureNotAvailablePage() {
  const { t } = useAppTranslation();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
      <h1 className="text-2xl font-semibold tracking-tight">{t("featureNotAvailable.title")}</h1>
      <p className="text-muted-foreground mt-2 max-w-md">{t("featureNotAvailable.description")}</p>
      <Link
        to="/dashboard"
        className="bg-primary text-primary-foreground hover:bg-primary/90 mt-6 inline-flex items-center rounded-md px-4 py-2 text-sm font-medium transition-colors"
      >
        {t("errors.goHome")}
      </Link>
    </div>
  );
}
